import clsx from 'clsx'
import type { ReactElement, ReactNode } from 'react'
import { View } from 'react-native'

import { Typography } from '@/src/elements/text/Typography'
import type { ICON } from '@/src/general/enums/icons'

import { ChatMessageHeader } from './ChatMessageHeader'

export type TChatMessageThumbnailProps = {
  color: 'default' | 'secondary'
  title: string | ReactElement
  icon?: ICON
  message: string
}

export const ChatMessageThumbnail = ({ color, title, icon, message }: TChatMessageThumbnailProps): ReactNode => (
  <View
    className={clsx('relative rounded-lg px-3 py-2 max-w-full', {
      'bg-white': color === 'default',
      'bg-secondary-bg-medium': color === 'secondary',
    })}
  >
    <View className="flex w-full max-w-full flex-col items-start justify-center gap-1">
      <ChatMessageHeader title={title} icon={icon} color={color} />
      <Typography size="xs" colors={color} className="flex-1 max-w-full">
        {message}
      </Typography>
    </View>
  </View>
)
